/* WEAK THINGS · Sketch-note image guard
   Makes casual saving of sketch-note images harder:
   - a transparent layer sits over each sketch-note image, so right-click and
     long-press land on the layer instead of the picture
   - the right-click menu and image dragging are turned off on these images
   - the iPhone/iPad long-press "Save Image" menu is turned off (CSS in theme.liquid)
   Clicks and taps on the layer are passed through to whatever is underneath,
   so cards, the viewer, zoom and arrows keep working. Screenshots are not blocked. */
(function () {
  'use strict';
  var PATTERNS = [
    '/files/wtsnw-', '/files/wt-snw-', '/files/wtsn-', '/files/wt-sn-20',
    '/files/ntss-', '/assets/ntss-', '/files/dl-a', '/files/dl-c', '/files/dl-t', '/files/dl-s'
  ];
  var SEL = 'img[data-wt-guard], .wt-guard-zone img';
  function isNote(img) {
    if (img.hasAttribute('data-wt-guard-off')) return false;
    if (img.matches && img.matches(SEL)) return true;
    var s = img.currentSrc || img.src || '';
    for (var i = 0; i < PATTERNS.length; i++) if (s.indexOf(PATTERNS[i]) > -1) return true;
    return false;
  }
  function stop(e) { e.preventDefault(); return false; }

  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (es) {
    es.forEach(function (en) { var l = en.target.__wtLayer; if (l) place(en.target, l); });
  }) : null;

  function place(img, layer) {
    if (!img.isConnected) { layer.remove(); return; }
    layer.style.left = img.offsetLeft + 'px';
    layer.style.top = img.offsetTop + 'px';
    layer.style.width = img.offsetWidth + 'px';
    layer.style.height = img.offsetHeight + 'px';
    layer.style.display = img.offsetWidth ? '' : 'none';
  }

  function guard(img) {
    if (img.__wtGuard || !isNote(img)) return;
    img.__wtGuard = true;
    img.classList.add('wt-guard');
    img.setAttribute('draggable', 'false');
    var p = img.parentElement;
    if (!p) return;
    /* only add a layer where it cannot disturb the layout: the picture must be the
       only image in its box, and nothing may move once the layer is in place */
    var kids = p.children, imgs = 0;
    for (var k = 0; k < kids.length; k++) if (kids[k].tagName === 'IMG' || kids[k].tagName === 'PICTURE') imgs++;
    if (imgs !== 1) return;
    var ip = getComputedStyle(img).position;
    if (ip === 'fixed') return;
    var before = img.getBoundingClientRect(), pb = p.getBoundingClientRect();
    var setPos = false;
    if (getComputedStyle(p).position === 'static') {
      if (ip === 'absolute') return; /* would move the picture; keep menu/drag blocking only */
      p.style.position = 'relative'; setPos = true;
    }
    var layer = document.createElement('span');
    layer.className = 'wt-guard-layer';
    layer.style.zIndex = 'auto'; /* stay under buttons and stops drawn on top of the picture */
    layer.setAttribute('aria-hidden', 'true');
    img.insertAdjacentElement('afterend', layer);
    var after = img.getBoundingClientRect(), pa = p.getBoundingClientRect();
    if (Math.abs(after.left - before.left) > 1 || Math.abs(after.top - before.top) > 1 ||
        Math.abs(after.width - before.width) > 1 || Math.abs(after.height - before.height) > 1 ||
        Math.abs(pa.width - pb.width) > 1 || Math.abs(pa.height - pb.height) > 1) {
      layer.remove(); if (setPos) p.style.position = ''; return;
    }
    img.__wtLayer = layer;
    place(img, layer);
    img.addEventListener('load', function () { place(img, layer); });
    if (ro) { ro.observe(img); }
  }

  /* pass clicks/taps on the layer through to what is underneath */
  document.addEventListener('click', function (e) {
    var l = e.target;
    if (!l.classList || !l.classList.contains('wt-guard-layer')) return;
    e.preventDefault(); e.stopPropagation();
    l.style.pointerEvents = 'none';
    var under = document.elementFromPoint(e.clientX, e.clientY);
    l.style.pointerEvents = '';
    if (under && under !== l) under.click();
  }, true);

  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t.classList && (t.classList.contains('wt-guard-layer') || t.classList.contains('wt-guard'))) return stop(e);
  }, true);
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (t.tagName === 'IMG' && (t.classList.contains('wt-guard') || isNote(t))) return stop(e);
  }, true);

  function scan(root) {
    if (root.tagName === 'IMG') { guard(root); return; }
    if (root.querySelectorAll) { var a = root.querySelectorAll('img'); for (var i = 0; i < a.length; i++) guard(a[i]); }
  }
  function resync() {
    var a = document.querySelectorAll('img.wt-guard');
    for (var i = 0; i < a.length; i++) if (a[i].__wtLayer) place(a[i], a[i].__wtLayer);
  }
  function start() {
    scan(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') { var t = m.target; if (t.tagName === 'IMG') { if (!t.__wtGuard) guard(t); else if (t.__wtLayer) place(t, t.__wtLayer); } return; }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    window.addEventListener('resize', resync);
    window.addEventListener('load', resync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
